<template>
    <div class="star-rating" :style="{ fontSize: size + 'px' }">
      <span
        v-for="star in totalStars"
        :key="star"
        @click="!disabled && rate(star)"
        @mouseover="!disabled && hoverStar(star)"
        @mouseleave="!disabled && resetHover"
        :class="{ filled: star <= currentRating }"
      >
        &#9733;
      </span>
    </div>
  </template>

  <script>
  export default {
    props: {
        rating: {
            type: Number,
            default: 0,
        },
        totalStars: {
            type: Number,
            default: 5,
        },
        size: {
            type: Number,
            default: 24, 
        },
        disabled: {
            type: Boolean,
            default: false, 
        },
    },
    data() {
      return {
        currentRating: this.rating,
        hoveringRating: null,
      };
    },
    mounted() {
        this.currentRating = this.rating;
    },
    methods: {
      rate(rating) {
        if (!this.disabled) { 
            this.currentRating = rating;
            this.$emit("rated", this.currentRating);
        }
      },
      hoverStar(rating) {
        if (!this.disabled) { 
            this.hoveringRating = rating;
        }
      },
      resetHover() {
        if (!this.disabled) { 
            this.hoveringRating = null;
        }
      },
    },
  };
  </script>

  <style scoped>
  /* Add your CSS styling here */
  .star-rating {
    cursor: pointer;
  }
  .filled {
    color: #4b9a5e; /* Change star color to gold */
  }
  </style>
